module.exports = __webpack_public_path__ + "media/images/email_542689-51b08bcbb5af7a861c316feb38f6f42a.png";